import { atom } from "jotai";
import { ExecuteZslResponse } from "@zapier/service-providers/src/zsl-api/execute";
import { Node } from "../types";
import { tablesAppAtom, interfacesAppAtom } from "../apps";
import { getAppServiceNodeData } from "../utils/parseStreamedCanvasEditsToNodeData";
import { uuid } from "../utils";

export const parseZslResponseToNodesAtom = atom(
  (get) =>
    (zsl: ExecuteZslResponse): Node[] => {
      const nodes: Node[] = [];
      const tablesApp = get(tablesAppAtom);
      const interfacesApp = get(interfacesAppAtom);

      if (!tablesApp || !interfacesApp) {
        throw new Error("Tables or interfaces app not found");
      }

      // Process zaps
      if (zsl.zaps) {
        Object.entries(zsl.zaps).forEach(([zapId, zap]) => {
          nodes.push({
            id: uuid(),
            type: "zap",
            position: { x: 0, y: 0 }, // Default position, adjust as needed
            data: {
              label: zap.title,
              zapId,
              isExpanded: false,
            },
          });
        });
      }

      // Process interfaces
      if (zsl.interfaces) {
        Object.entries(zsl.interfaces).forEach(([, interface_]) => {
          nodes.push({
            id: uuid(),
            type: "default",
            position: { x: 0, y: 0 }, // Default position, adjust as needed
            data: {
              label: interface_.name,
              ...getAppServiceNodeData(
                "Interfaces by Zapier",
                interfacesApp.current_implementation_id,
              ),
              projectId: interface_.id,
            },
          });
        });
      }

      // Process tables
      if (zsl.tables) {
        Object.entries(zsl.tables).forEach(([, table]) => {
          nodes.push({
            id: uuid(),
            type: "default",
            position: { x: 0, y: 0 }, // Default position, adjust as needed
            data: {
              label: table.name,
              ...getAppServiceNodeData(
                "Tables by Zapier",
                tablesApp.current_implementation_id,
              ),
              tableId: table.id,
            },
          });
        });
      }

      return nodes;
    },
);

parseZslResponseToNodesAtom.debugLabel = "parseZslResponseToNodesAtom";
